/* Product gallery on phones: clean videos (no player bar, only the sound button bottom right)
   and swipe left / right on the big photo to change media. */
(function () {
  var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/></svg>';

  var css = document.createElement('style');
  css.textContent =
    '.ew-gallery__main video::-webkit-media-controls,.ew-gallery__main video::-webkit-media-controls-panel,' +
    '.ew-gallery__main video::-webkit-media-controls-start-playback-button,.ew-gallery__main video::-webkit-media-controls-overlay-play-button{display:none!important;-webkit-appearance:none}' +
    '.ew-gallery__main{touch-action:pan-y}' +
    '.ew-gallery__main video{pointer-events:none}';
  document.head.appendChild(css);

  function cleanVideo(v, box) {
    if (v.dataset.ewClean) return;
    v.dataset.ewClean = '1';
    v.controls = false;
    v.removeAttribute('controls');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', '');
    v.loop = true;
    v.playsInline = true;
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
    if (!box.querySelector('.ew-sound')) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ew-sound'; b.setAttribute('aria-label', 'Activer ou couper le son');
      var paint = function () { b.innerHTML = v.muted ? ICON_OFF : ICON_ON; };
      b.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; if (!v.muted) v.volume = 1; paint(); });
      v.addEventListener('volumechange', paint);
      paint(); box.appendChild(b);
    }
  }

  function visibleThumbs(g) {
    return Array.prototype.filter.call(g.querySelectorAll('.ew-gallery__thumb'), function (t) {
      return t.offsetParent !== null && getComputedStyle(t).display !== 'none';
    });
  }

  function go(g, dir) {
    var list = visibleThumbs(g);
    if (list.length < 2) return;
    var cur = list.indexOf(g.querySelector('.ew-gallery__thumb.is-active'));
    if (cur < 0) cur = 0;
    var next = list[(cur + dir + list.length) % list.length];
    next.click();
    var wrap = next.parentElement;
    if (wrap && wrap.scrollWidth > wrap.clientWidth) {
      wrap.scrollTo({ left: next.offsetLeft - wrap.clientWidth / 2 + next.clientWidth / 2, behavior: 'smooth' });
    }
  }

  function initGallery(g) {
    if (g.dataset.ewMobile) return;
    g.dataset.ewMobile = '1';
    var box = g.querySelector('.ew-gallery__main');
    if (!box) return;
    box.querySelectorAll('video').forEach(function (v) { cleanVideo(v, box); });
    new MutationObserver(function () {
      box.querySelectorAll('video').forEach(function (v) { cleanVideo(v, box); });
      if (!box.querySelector('video')) { var s = box.querySelector('.ew-sound'); if (s) s.remove(); }
    }).observe(box, { childList: true });

    var x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) {
      if (e.target.closest('.ew-sound')) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(g, dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function init() { document.querySelectorAll('[data-ew-gallery]').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();

/* Product info column on computer: when it is taller than the screen, let it scroll
   until its bottom (buy button) is visible, then stick. */
(function () {
  function fit() {
    var mq = window.matchMedia('(min-width: 990px)').matches;
    document.querySelectorAll('.ew-pdp__info').forEach(function (el) {
      if (!mq) { el.style.top = ''; return; }
      var h = el.offsetHeight, vh = window.innerHeight, head = 90;
      el.style.top = (h + head + 24 > vh ? Math.round(vh - h - 24) : head) + 'px';
    });
  }
  function start() {
    fit();
    if (window.ResizeObserver) { var ro = new ResizeObserver(fit); document.querySelectorAll('.ew-pdp__info').forEach(function (el) { ro.observe(el); }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
})();
